<template>
  <b-avatar-group :size="avatarGroupSize" :style="avatarGroupStyles" :overlap="overlap">
    <b-avatar
      v-for="user in displayUsers"
      :key="`avatar__teacher--${user.id}`"
      :text="user.userProfileText()"
      variant="dark"
    />

    <b-avatar v-if="shouldDisplayExceedUsers" :text="`+${exceedUsers}`" variant="dark" />
  </b-avatar-group>
</template>

<script>
export default {
  props: {
    avatarGroupSizePx: {
      type: Number,
      default: 44
    },

    users: {
      type: Array,
      default: () => []
    },

    limit: {
      type: Number,
      default: 2
    },

    overlap: {
      type: Number,
      default: 0.3
    }
  },

  computed: {
    avatarGroupSize() {
      return `${this.avatarGroupSizePx}px`;
    },

    displayUsers() {
      return this.users.slice(0, this.limit);
    },

    shouldDisplayExceedUsers() {
      return this.users.length > this.limit;
    },

    exceedUsers() {
      return this.users.length - this.limit;
    },

    avatarGroupStyles() {
      const { limit, avatarGroupSizePx } = this;

      return {
        minWidth: `${avatarGroupSizePx * limit}px`
      };
    }
  }
};
</script>
